export default function(_) {
  return typeof _ === 'number';
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-util/src/isNumber.js
// module id = 228
// module chunks = 0